<template>
  <div class="repair">
    <div class="title" style="width: 40%;">
      <div class="title-text">设备总览</div>
    </div>
    <table>
      <thead>
        <tr>
          <td>设备编号</td>
          <td>设备名称</td>
          <td>维修内容</td>
          <td>维修人员</td>
          <td>维修状态</td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>AK001</td>
          <td>A区电子围栏</td>
          <td>断电</td>
          <td>李白</td>
          <td class="done">已维修<img src="../../assets/equipment/done.png" alt=""></td>
        </tr>
        <tr class="undone">
          <td>AK001</td>
          <td>A区电子围栏</td>
          <td>断电</td>
          <td>李白</td>
          <td>待维修 <img src="../../assets/equipment/undone.png" alt=""></td>
        </tr>
        <tr>
          <td>AK001</td>
          <td>A区电子围栏</td>
          <td>断电</td>
          <td>李白</td>
          <td class="done">已维修<img src="../../assets/equipment/done.png" alt=""></td>
        </tr>
        <tr>
          <td>AK001</td>
          <td>A区电子围栏</td>
          <td>断电</td>
          <td>李白</td>
          <td class="done">已维修<img src="../../assets/equipment/done.png" alt=""></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  components: {

  },
  methods: {

  },

}
</script>

<style scoped lang="less">
  .repair{
    height: 90%;
    width: 35%;
    table{
      width: 100%;
      color: #FFFFFF;
      font-family: '微软雅黑';
      border-collapse: collapse;
      font-size: 12px;
      text-align: center;
      margin-top: 1vh;
      td{
        padding: 8px 0;
      }
      thead{
        background-color: rgba(152, 254, 249,0.302);
      }
      tbody{
        tr{
          border-bottom: 1px dashed rgb(152, 254, 249);
          &.undone{
            color: #f39104;
          }
          td{
            &.done{
              color: rgb(48, 199, 77);
            }
          }
        }
      }
    }
  }
</style>
